export enum OverlayTabEnum {
  DETAILS = "DETAILS",
  DOCUMENTS = "DOCUMENTS",
  CERTIFICATES = "CERTIFICATES",
  ATTACHED_TO = "ATTACHED_TO",
  SUPPLY_CHAIN = "SUPPLY_CHAIN",
  PROCESSES = "PROCESSES",
  DELIVERIES = "DELIVERIES",
  LOCATIONS = "LOCATIONS",
  ITEMS = "ITEMS",
  SHARES = "SHARES",
  COMMENTS = "COMMENTS",
  GPS_DATA = "GPS_DATA",
  ANALYSES = "ANALYSES",
  LINKED_LOCATIONS = "LINKED_LOCATIONS",
  INPUTS = "INPUTS",
  OUTPUTS = "OUTPUTS",
  RELATED_PRODUCTS = "RELATED_PRODUCTS",
  INDICATORS = "INDICATORS",
  RISK_ASSESSMENT_REPORTS = "RISK_ASSESSMENT_REPORTS",
  REFERENCED_RISK_ASSESSMENT_REPORTS = "REFERENCED_RISK_ASSESSMENT_REPORTS",
}
